import { Navigate, useLocation, useParams } from 'react-router-dom';

/** Shared tabs for the professional backlink tool and its sidebar navigation. */
export const backlinkTabRoutes = {
  children: [
    { name: 'نمای کلی', to: '/backlink/overview' },
    { name: 'بک‌لینک', to: '/backlink/backlinks' },
    { name: 'دامنه ارجاع', to: '/backlink/referral-domain' },
    { name: 'دامنه اسپم', to: '/backlink/spam-domain' },
    { name: 'IP ارجاع', to: '/backlink/referring-ip' },
    { name: 'متن پیوند', to: '/backlink/anchor-text' },
    { name: 'نشانی پیوند', to: '/backlink/internal-page' },
    {
      name: 'تقاطع پیوند (بزودی)',
      to: '/backlink/gap',
      active: true,
      disabled: true
    }
  ]
};

/** Gap tab is disabled; keep domain path + query and land on overview. */
export const GapPageRedirect = () => {
  const location = useLocation();
  const { domain_slug: domainSlug, domain: domainName } = useParams();
  const query = location.search || '';
  const domainSegment =
    domainSlug && domainName ? `/${domainSlug}/${domainName}` : '';
  return (
    <Navigate
      to={`/backlink/overview${domainSegment}${query}`}
      replace
    />
  );
};

/** Legacy `/referral-page` → `/backlinks` (keeps domain path + query). */
export const ReferralPageRedirect = () => {
  const location = useLocation();
  const { domain_slug: domainSlug, domain: domainName } = useParams();
  const query = location.search || '';
  const domainSegment =
    domainSlug && domainName ? `/${domainSlug}/${domainName}` : '';
  return (
    <Navigate to={`/backlink/backlinks${domainSegment}${query}`} replace />
  );
};

/** Build a backlink tool URL from path segments; keep non-u/m query (filters, grouping). */
export const buildBacklinkUrl = (
  routeTo,
  domainSlug,
  domainName,
  searchParams
) => {
  const params = new URLSearchParams(searchParams?.toString?.() || '');
  params.delete('u');
  params.delete('m');

  const query = params.toString();
  const domainSegment =
    domainSlug && domainName ? `/${domainSlug}/${domainName}` : '';

  return `${routeTo}${domainSegment}${query ? `?${query}` : ''}`;
};
